import type { CheckStatus } from "@statuspage/shared";

interface StatusBadgeProps {
  status: CheckStatus | null;
}

const BADGE_CONFIG: Record<string, { bg: string; text: string; label: string }> = {
  up: {
    bg: "bg-green-100 dark:bg-green-900/40",
    text: "text-green-800 dark:text-green-200",
    label: "Operational",
  },
  degraded: {
    bg: "bg-yellow-100 dark:bg-yellow-900/40",
    text: "text-yellow-800 dark:text-yellow-200",
    label: "Degraded",
  },
  down: {
    bg: "bg-red-100 dark:bg-red-900/40",
    text: "text-red-800 dark:text-red-200",
    label: "Down",
  },
  timeout: {
    bg: "bg-red-100 dark:bg-red-900/40",
    text: "text-red-800 dark:text-red-200",
    label: "Down",
  },
};

export default function StatusBadge({ status }: StatusBadgeProps) {
  const key = status ?? "unknown";
  const config = BADGE_CONFIG[key] ?? {
    bg: "bg-gray-100 dark:bg-slate-800",
    text: "text-gray-600 dark:text-slate-300",
    label: "Unknown",
  };

  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${config.bg} ${config.text}`}
      aria-label={`Status: ${config.label}`}
    >
      {config.label}
    </span>
  );
}
